/** @format */

const template = `
<button
  class="row attainment clickable non-button-inherit"
  id="{{$ctrl.row.id + '-details-button'}}"
  ng-click="$ctrl.onAttainmentClick({row: $ctrl.row})"
  ng-class="{'module': $ctrl.row.attainment.type === 'ModuleAttainment' ||  $ctrl.row.attainment.type === 'CustomModuleAttainment',
     'valid-attainment': $ctrl.attainmentsDisplayed === 'INVALID' && $ctrl.row.isValid}"
  role="button"
  aria-label="{{$ctrl.row.name|localizedString}} {{'ARIA_LABEL.OPEN_ATTAINMENTS_INFO' | translate}}">
  <div class="name-child" ng-class="{'col-4': $ctrl.showMenuButton, 'col-6': !$ctrl.showMenuButton}">
    <span class="name">{{$ctrl.row.name|localizedString}}</span>
    <span
      ng-if="$ctrl.row.expired && !$ctrl.row.hasValidParentAttainment"
      class="tiny-badge secondary"
      translate="PROFILE.ATTAINMENT.EXPIRED"></span>
    <span ng-if="$ctrl.row.misregistration" class="tiny-badge danger" translate="PROFILE.ATTAINMENT.MISREGISTRATION"></span>
    <span ng-if="!$ctrl.row.primary" class="tiny-badge secondary" translate="PROFILE.ATTAINMENT.NOT_PRIMARY"></span>
    <span ng-if="$ctrl.row.isAboutToExpire && !$ctrl.row.hasValidParentAttainment" class="tiny-badge danger">
      <span translate="PROFILE.ATTAINMENT.EXPIRATION_IMMINENT"></span>
      {{$ctrl.row.attainment.expiryDate | localDateFormat}}
    </span>
    <span ng-if="$ctrl.attainmentsDisplayed === 'INVALID' && $ctrl.row.isValid" class="valid-attainment">
      ({{'PROFILE.ATTAINMENT.VALID_ATTAINMENT'|translate}})
    </span>
    <span ng-if="$ctrl.row.code" class="code-child">{{$ctrl.row.code}}</span>
  </div>
  <div class="col-2 credit">
    <span ng-if="$ctrl.row.credits" translate="PROFILE.ATTAINMENT.CREDIT_AMOUNT" translate-value-credits="{{$ctrl.row.credits}}"> </span>
  </div>
  <div class="col-2 grade">{{$ctrl.row.grade.abbreviation | localizedString}}</div>
  <div class="col-2 date">{{$ctrl.row.attainmentDate|date:'d.M.yyyy'}}</div>
  <div class="col-2 attainment-row-menu-button" ng-if="$ctrl.showMenuButton" ng-click="$event.stopPropagation()"
    ><sis-attainment-row-menu-button
      [attainment]="$ctrl.row.attainment"
      (attainment-edit-action-selected)="$ctrl.attainmentEditActionSelected({event: $event})"></sis-attainment-row-menu-button
  ></div>
</button>
`;
export default template;
